import { render, staticRenderFns } from "./addRuKuPlan.vue?vue&type=template&id=0c2f4162&"
import script from "./addRuKuPlan.vue?vue&type=script&lang=js&"
export * from "./addRuKuPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports